import React from 'react';
import pt from 'prop-types';
import cx from 'classnames';
import { sanitizeHtml } from 'utils/sanitize';
import Status from 'components/status';
import { formatDate } from 'utils';

import AppReviewCommentAuthor from './comment-author';

export default class AppReviewComment extends React.PureComponent {
  static propTypes = {
    comment: pt.object.isRequired,
    actions: pt.node,
    children: pt.node,
  };

  render() {
    const { comment, actions, children } = this.props;
    const { user, comment: body, date_created: dateCreated } = comment;

    return (
      <div
        className={cx('review-comments--comment', {
          'review-comments--comment-internal': comment.internal,
        })}
      >
        <div className="review-comments--comment--header">
          <div className="review-comments--comment--author">
            <AppReviewCommentAuthor user={user} />
            {comment.internal && (
              <Status
                className="review-comments--badge-internal"
                type="muted"
                size="sm"
                dot={false}
              >
                Internal
              </Status>
            )}
            <span className="review-comments--comment--date">
              &bull; {formatDate(dateCreated, 'ago')}
            </span>
          </div>
          {actions}
        </div>
        {children || (
          <div
            className="review-comments--comment--body fr-element fr-view"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(body) }}
          />
        )}
      </div>
    );
  }
}
